import React, { useEffect, useRef } from "react";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock09.jpeg';
import mock04 from '../assets/images/mock04.jpeg';
import mock05 from '../assets/images/mock05.jpg';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/mock07.png';
import mock08 from '../assets/images/mock08.png';
import mock09 from '../assets/images/mock11.jpeg';
import mock10 from '../assets/images/mock10.png';
import mock11 from '../assets/images/mock12.png';
import mock12 from '../assets/images/mock12.jpg';
import mock13 from '../assets/images/mock13.jpg';
import mock14 from '../assets/images/mock14.jpg';
import '../assets/styles/Project.scss';

const projectData = [
    {
        title: "Al-Jadriya Towers Management System",
        category: "Enterprise Web Application",
        description: "Developed a comprehensive real estate management system. The platform allows users to explore building floors in 3D, check availability status in real-time, and provides administrators with powerful tools to manage property data efficiently.",
        image: mock10,
        tags: ["React", "Node.js", "MongoDB", "Three.js"],
        link: "https://www.jtp-iq.com"
    },
    {
        title: "Zain Islamic Bank Platform",
        category: "FinTech Website",
        description: "Designed and delivered a professional banking portal for Zain Islamic Bank Iraq. The project featured high-security standards, premium hosting configuration, custom domain integration, and a modern, responsive user interface.",
        image: mock09,
        tags: ["React", "TypeScript", "Tailwind CSS", "Framer Motion"],
        link: "https://zainbank.iq/"
    },
    {
        title: "Dijlah Village Experience",
        category: "Business Portal",
        description: "Created an immersive digital experience for Dijlah Village, showcasing luxury facilities, services, and residential features. The site focuses on high-performance image loading and smooth scroll animations.",
        image: mock05,
        tags: ["Next.js", "SASS", "GSAP", "REST API"],
        link: "#"
    },
    {
        title: "OIGATECH 2026 Automation",
        category: "Event Automation System",
        description: "Architected an automated registration bot for OIGATECH 2026. The Node.js based system manages thousands of concurrent employee registrations and instantly generates personalized PDF conference badges via WhatsApp.",
        image: mock12,
        tags: ["Node.js", "PDF-lib", "WhatsApp API", "Redis"],
        link: "https://thedijlahvillage.com/"
    },
    {
        title: "Iraqdex Business Platform",
        category: "B2B Exhibition Platform",
        description: "Built a scalable digital platform for Iraqdex to manage international exhibitions. Features include participant management, interactive business listings, and integrated communication services via WhatsApp and Email.",
        image: mock13,
        tags: ["MERN Stack", "Socket.io", "JWT", "AWS"],
        link: "#"
    },
    {
        title: "Warehouse Management System",
        category: "Internal Tooling",
        description: "Developed a smart warehouse management system for Space Engineering. Enables storekeepers to seamlessly sell, rent, or assign equipment with comprehensive history tracking and automated inventory alerts.",
        image: mock02,
        tags: ["React", "Express", "PostgreSQL", "Docker"],
        link: "#"
    },
    {
        title: "Line Ads Taxi Advertising Website",
        category: "Business Website",
        description: "Designed and developed a professional website for Line Ads, a taxi advertising services company. The project included premium hosting and custom domain setup, completed within 15 days with one year of technical support.",
        image: mock14,
        tags: ["React", "CSS", "Hosting", "Domain"],
        link: "#"
    },
    {
        title: "Space Engineering Company Website",
        category: "Corporate Website",
        description: "Designed and developed a professional corporate website for Space Engineering Company in Basra, Iraq, specializing in engineering, architectural design, and surveying services.",
        image: mock08,
        tags: ["React", "SEO", "Responsive Design", "Performance"],
        link: "https://www.sec.iq/"
    },
    {
        title: "GPSLVN Fleet Management System",
        category: "Fleet Management",
        description: "Contributed to the development of a professional fleet management system for GPSLVN, designed to monitor and manage vehicles in real-time with Laravel backend support.",
        image: mock04,
        tags: ["React", "Laravel", "Real-time", "Monitoring"],
        link: "#"
    },
    {
        title: "GPSLVN Admin Management System",
        category: "Admin Dashboard",
        description: "Developed an admin dashboard for the GPSLVN fleet management platform to manage users, companies, and subscription plans with intuitive interfaces.",
        image: mock03,
        tags: ["React", "Dashboard", "User Management", "Admin"],
        link: "#"
    },
    {
        title: "Clinic Zone Official Website",
        category: "Medical Platform",
        description: "Developed the official website for Clinic Zone, a medical appointment platform with AI-powered features to understand patient needs and provide smart recommendations.",
        image: mock07,
        tags: ["React", "AI", "Medical", "Appointment"],
        link: "#"
    },
    {
        title: "Clinic Zone: Medical Appointment System",
        category: "Healthcare System",
        description: "Developed Clinic Zone, a comprehensive medical appointment management system with real-time booking, doctor profiles, and admin dashboard for full clinic management.",
        image: mock06,
        tags: ["React", "Node.js", "MongoDB", "Express"],
        link: "#"
    },
    {
        title: "Dream Interpretation Website",
        category: "Early Project",
        description: "Developed a dream interpretation website as an early programming project, collecting and structuring data using web scraping techniques for easy dream meaning exploration.",
        image: mock01,
        tags: ["Web Scraping", "Data Collection", "Early Project"],
        link: "#"
    },
    {
        title: "Moon: Movie & Series Streaming Platform",
        category: "Streaming Service",
        description: "Developed Moon, a modern streaming platform for watching movies and TV series with a simple subscription model and ad-free experience with smooth user interface.",
        image: mock11,
        tags: ["Streaming", "Subscription", "UI/UX", "Video"],
        link: "#"
    }
];

function Project() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('reveal');
                        // Optional: Unobserve after revealing to keep it visible
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
        );

        const cards = document.querySelectorAll('.project-card');
        const headers = document.querySelectorAll('.section-header');
        
        cards.forEach((card) => observer.observe(card));
        headers.forEach((header) => observer.observe(header));

        return () => observer.disconnect();
    }, []);

    return(
        <section className="projects-container" id="projects" ref={sectionRef}>
            <div className="container">
                <div className="section-header">
                    <span className="subtitle">Selected Work</span>
                    <h2>Featured <span className="text-gradient">Projects</span></h2>
                    <div className="header-line"></div>
                </div>

                <div className="projects-grid">
                    {projectData.map((project, index) => (
                        <div 
                            className="project-card" 
                            key={index}
                            style={{ animationDelay: `${index * 0.1}s` }}
                        >
                            <div className="project-image">
                                <img src={project.image} alt={project.title} loading="lazy" />
                                <div className="overlay">
                                    <div className="overlay-content">
                                        <a href={project.link} target="_blank" rel="noreferrer" className="btn-glass">
                                            <span>Live Preview</span>
                                            <OpenInNewIcon fontSize="small" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="project-content">
                                <span className="project-category">{project.category}</span>
                                <h3>{project.title}</h3>
                                <p>{project.description}</p>
                                
                                <div className="project-tags">
                                    {project.tags.map((tag, idx) => (
                                        <span key={idx} className="tag">{tag}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Project;
